const popupInstances = new Map<string, Record<string, any>>()
const popupOpenedSet = new Set<string>()
const popupCountdownTimers = new Map<string, number>()
const COUNTDOWN_TIMER_SELECTOR = '.countdown-timer'
const COUNTDOWN_MILLISECONDS = 30 * 1000
const COUNTDOWN_INTERVAL = 10

function startPopupCountdown(selector: string) {
    const $timer = $(`${selector} ${COUNTDOWN_TIMER_SELECTOR}`)

    if (!$timer.length) {
        return
    }

    const previousTimer = popupCountdownTimers.get(selector)
    if (previousTimer !== undefined) {
        window.clearInterval(previousTimer)
    }

    let remainingMilliseconds = COUNTDOWN_MILLISECONDS
    const render = () => {
        const minutes = Math.floor(remainingMilliseconds / 60000)
        const seconds = Math.floor((remainingMilliseconds % 60000) / 1000)
        const centiseconds = Math.floor((remainingMilliseconds % 1000) / 10)
        $timer.text(
            [minutes, seconds, centiseconds]
                .map((value) => String(value).padStart(2, '0'))
                .join(':')
        )
    }

    render()
    const timer = window.setInterval(() => {
        remainingMilliseconds = Math.max(
            remainingMilliseconds - COUNTDOWN_INTERVAL,
            0
        )
        render()

        if (remainingMilliseconds === 0) {
            window.clearInterval(timer)
            popupCountdownTimers.delete(selector)
        }
    }, COUNTDOWN_INTERVAL)
    popupCountdownTimers.set(selector, timer)
}

export function usePopup() {
    const set = (selector: string, instance: Record<string, any>) => {
        popupOpenedSet.add(selector)
        popupInstances.set(selector, instance)
    }

    const has = (selector: string) => {
        return popupInstances.has(selector)
    }

    const isOpened = (selector: string) => {
        return !!$(selector).is(':visible')
    }

    const haveOpened = (selector: string) => {
        return popupOpenedSet.has(selector)
    }

    const openPopup = (selector: string, options?: Record<string, any>) => {
        closePopupAll()

        if (typeof $.fn.bPopup !== 'function') {
            $(selector).show()
            const instance = {
                close: () => $(selector).hide(),
            }
            set(selector, instance)
            startPopupCountdown(selector)
            return instance
        }

        const instance = $(selector).bPopup({
            closeClass: 'b-close',
            modalClose: true,
            opacity: 0.82,
            positionStyle: 'fixed',
            ...options,
        })
        set(selector, instance)
        startPopupCountdown(selector)
        return instance
    }

    const closePopup = (selector: string) => {
        const instance = popupInstances.get(selector)
        instance?.close?.()
        popupInstances.delete(selector)
    }

    const closePopupAll = () => {
        popupInstances.forEach((instance) => {
            try {
                instance?.close?.()
            } catch {
                // 已关闭的弹窗再次调用 close 会报错。
            }
        })
        popupInstances.clear()
        $('.popup-panel:visible').hide()
    }

    return {
        set,
        has,
        isOpened,
        haveOpened,
        openPopup,
        closePopup,
        closePopupAll,
    }
}
